import React from "react";
import OrdersBasicTable from "../../OrdersBasicTable";
const Order = ({ data = {} }) => {
  return (
    <div>
      <h2>Basic</h2>
      <OrdersBasicTable data={data} />
    </div>
  );
};
export default Order;
